import React, { useState } from "react";

import {
  SUGGEST_MIN_LENGTH,
  useProductSuggestions,
} from "../../hooks/queries/useProductSuggestions";
import { ProductSelectionParams } from "../../services/productPlaneApi";
import { SuggestionGroup } from "../../types/productPlane";
import ExploreSearchField from "./ExploreSearchField";
import { FlatSuggestion } from "./ExploreSuggestions";

const NO_SUGGESTION_GROUPS: readonly SuggestionGroup[] = [];

interface ExploreSuggestFieldProps {
  // The products Explore shows, which the suggestions are counted under
  selection: ProductSelectionParams;
  keyword: string;
  onSubmit: (keyword: string) => void;
  subject: string;
  placeholder: string;
  onPickSuggestion: (picked: FlatSuggestion) => void;
}

// Explore's search field with the suggestions for the text typed into it.
// The text and its suggestions are held here rather than by the view, so
// that a pause in the typing and the answer to it render the field and its
// list alone, not the filters and the results beside it.
const ExploreSuggestField: React.FC<ExploreSuggestFieldProps> = ({
  selection,
  ...props
}) => {
  // The text typed, once the typing paused, and the filter values and
  // products it names. An answer for a text no longer asked is not shown.
  const [suggestText, setSuggestText] = useState("");
  const { data: suggested } = useProductSuggestions(suggestText, selection);
  const suggestions =
    suggestText.trim().length >= SUGGEST_MIN_LENGTH && suggested
      ? suggested.groups
      : NO_SUGGESTION_GROUPS;

  return (
    <ExploreSearchField
      {...props}
      onAsk={setSuggestText}
      suggestions={suggestions}
    />
  );
};

export default ExploreSuggestField;
